import classnames from 'classnames';

import { useLoadingState } from '@hh.ru/magritte-common-use-loading-state';
import { CellProps } from '@hh.ru/magritte-ui-cell/types';
import { Skeleton, IncompleteSkeletonComponent } from '@hh.ru/magritte-ui-skeleton';

import styles from './styles.less';

export const CellSkeleton: IncompleteSkeletonComponent<CellProps> = ({
    Component: Cell,

    // skeleton props
    // width остается в cellProps
    height,
    borderRadius,
    inline,
    additionalClass,
    loading,

    ...cellProps
}) => {
    const isLoading = useLoadingState() || loading;

    if (isLoading) {
        return (
            <div
                className={classnames({
                    [styles.vertPaddingSkeleton]: cellProps.vertPadding,
                    [styles.horPaddingSkeleton]: cellProps.horPadding,
                })}
                style={{ width: cellProps.width }}
            >
                <Skeleton width="100%" height={height} borderRadius={borderRadius} loading={isLoading} />
            </div>
        );
    }

    return <Cell {...cellProps} />;
};
